import React, { useEffect, useState } from 'react';
import Sidebar from '../../General/Sidebar/Sidebar';
import { Divider } from '@mui/material';
import ResizeableDrawer from '../../General/ResizeableDrawer/ResizeableDrawer';
import ImportViewTree from './ImportViewTree';
import { IAppReduxStore } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setExpandedNodes, setSearchText } from '../../../redux/import/sliceImportData';
import { leftSidepanelMinWidth, sidepanelMaxWidth } from '../../../Constants';
import { SidepanelVisibilityEnum } from '../../../redux/user/sliceUserSettings';

export default () => {
    const dispatch = useDispatch();
    const sidepanelVisibility = useSelector(
        (store: IAppReduxStore) => store.userSettings.data.sidepanelVisibility,
    );

    const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);

    const searchText = useSelector((store: IAppReduxStore) => store.importData.searchText);
    const currentImportView = useSelector((store: IAppReduxStore) => store.importData.currentView);

    useEffect(() => {
        setSidebarOpen(sidepanelVisibility === SidepanelVisibilityEnum.expanded);
    }, [sidepanelVisibility, currentImportView]);

    const onSearchChanged = (newSearchText: string) => {
        dispatch(setSearchText(newSearchText));
    };

    const onExpandCollapse = (expand: boolean) => {
        dispatch(setExpandedNodes(expand ? 'all' : []));
    };

    const sidebar = (
        <Sidebar
            tree={<ImportViewTree />}
            openState={[sidebarOpen, setSidebarOpen]}
            handleSearchChange={onSearchChanged}
            handleToggleAllExpanded={onExpandCollapse}
            searchQuery={searchText}
        />
    );

    if (!sidebarOpen) {
        return (
            <>
                {sidebar}
                <Divider orientation='vertical' flexItem />
            </>
        );
    }

    return (
        <ResizeableDrawer minWidth={leftSidepanelMinWidth} maxWidth={sidepanelMaxWidth}>
            {sidebar}
        </ResizeableDrawer>
    );
};
